module.exports = __webpack_public_path__ + "img/q5-1-6@2x.f382c28d.png";